var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextMultilineField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_text-lines-solid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85713 8.92853C2.19865 8.92853 1.66666 9.46052 1.66666 10.119C1.66666 10.7775 2.19865 11.3095 2.85713 11.3095H17.1428C17.8013 11.3095 18.3333 10.7775 18.3333 10.119C18.3333 9.46052 17.8013 8.92853 17.1428 8.92853H2.85713ZM2.85713 4.16663C2.19865 4.16663 1.66666 4.69862 1.66666 5.3571C1.66666 6.01558 2.19865 6.54758 2.85713 6.54758H17.1428C17.8013 6.54758 18.3333 6.01558 18.3333 5.3571C18.3333 4.69862 17.8013 4.16663 17.1428 4.16663H2.85713Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 15.0595C1.66666 14.401 2.19865 13.869 2.85713 13.869H9.99999H9.58332C10.2418 13.869 10.7738 14.401 10.7738 15.0595C10.7738 15.718 10.2418 16.25 9.58332 16.25H9.99999H2.85713C2.19865 16.25 1.66666 15.718 1.66666 15.0595Z",
    fill: "#B4B4B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextMultilineField);
export default __webpack_public_path__ + "static/media/text-multiline-field.719f240ae2914b14987164b5665f3496.svg";
export { ForwardRef as ReactComponent };